export default __webpack_public_path__ + "static/media/dallas-mavericks.433677d4.jpeg";